import React from "react";
import {Field, reduxForm} from "redux-form";
import validator from 'validator';
import { renderTextField } from "../helpers/formFields";
import Button from '@mui/material/Button';

class DetailsForm extends React.Component {

    onSubmit = (formValues) => {
        this.props.onSubmit(formValues);
    } 

    render() {
        return (
            <form onSubmit={this.props.handleSubmit(this.onSubmit)}>
                <Field 
                    name="firstname"
                    id="firstname"
                    component={renderTextField} 
                    label="First Name"
                    // autoFocus
                    margin="normal"
                    required
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                />
                <Field 
                    name="lastname"
                    id="lastname"
                    component={renderTextField} 
                    label="Last Name"
                    // autoFocus
                    margin="normal"
                    required
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                />                 
                <Field 
                    name="email"
                    id="email"
                    component={renderTextField} 
                    label="Email Address"
                    autoComplete="email"
                    // autoFocus
                    margin="normal"
                    disabled={this.props.authFlow !== 'password'}
                    required
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                />               
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                >
                    Save
                </Button>
            </form>
        )
    }    

}

const validate = (formValues) => {
    const errors = {};

    if (!formValues.firstname) {
        errors.firstname = 'You did not enter a first name';
    }

    if (!formValues.lastname) {
        errors.lastname = 'You did not enter a last name';
    }    

    if (!formValues.email) {
        errors.email = 'You must enter a email';    
    }

    if (formValues.email) {
        if (!validator.isEmail(formValues.email)) {
            errors.email = 'You must enter a valid email';    
        }
    }    

    return errors;
};

export default reduxForm({
    form: 'detailsForm',
    validate: validate
})(DetailsForm);